import { render, staticRenderFns } from "./ProductionDateStock.vue?vue&type=template&id=01bf42dc&"
import script from "./ProductionDateStock.vue?vue&type=script&lang=ts&"
export * from "./ProductionDateStock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionDateStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VDatePicker,VFlex,VForm,VLayout,VMenu,VSelect,VTextField})
